import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarArrowRight = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 12,
	viewBox: "0 0 13 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.21875 0.691406C6.94531 0.445312 6.53516 0.445312 6.28906 0.71875C6.04297 0.964844 6.04297 1.40234 6.31641 1.64844L9.95312 5.12109H0.65625C0.273438 5.12109 0 5.39453 0 5.77734C0 6.13281 0.273438 6.43359 0.65625 6.43359H9.95312L6.31641 9.87891C6.04297 10.125 6.04297 10.5625 6.28906 10.8086C6.53516 11.082 6.94531 11.082 7.21875 10.8359L12.0312 6.24219C12.168 6.10547 12.2227 5.94141 12.2227 5.77734C12.2227 5.58594 12.168 5.42188 12.0312 5.28516L7.21875 0.691406Z",
		fill: "#90A4AE"
	})]
});
const ForwardRef = forwardRef(SvgCalendarArrowRight);
export { ForwardRef as ReactComponent };
